import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';

export default function FloatingButtons() {
  return (
    <div className="fixed right-4 md:right-6 bottom-4 md:bottom-6 z-40 flex flex-col gap-3">
      <a
        href="https://wa.me/918482031021"
        target="_blank"
        rel="noreferrer"
        aria-label="WhatsApp"
        className="group w-12 h-12 md:w-14 md:h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white flex items-center justify-center shadow-xl shadow-emerald-500/40 transition-all hover:-translate-y-1"
      >
        <MessageCircle className="w-5 h-5 md:w-6 md:h-6" />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hidden md:inline-block">
          Chat on WhatsApp
        </span>
      </a>
      <a
        href="tel:+918482031021"
        aria-label="Call"
        className="group w-12 h-12 md:w-14 md:h-14 rounded-full bg-blue-600 hover:bg-blue-500 text-white flex items-center justify-center shadow-xl shadow-blue-600/40 transition-all hover:-translate-y-1"
      >
        <Phone className="w-5 h-5 md:w-6 md:h-6" />
        <span className="absolute right-full mr-3 whitespace-nowrap bg-slate-900 text-white text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity hidden md:inline-block">
          Call Now
        </span>
      </a>
    </div>
  );
}
